export let dto_Merchant = {
  MID: Number,
  Merchant: String,
  Add1: String,
  Add2: String,
  Add3: String,
  ImageURL: String,
  IO: Boolean,
  ServiceChargePer: Number,
  ZoneID: Number,
  Zone: String,
  MinBillValue: Number,
  EstTime: String,
  MerchantType: String,
  MerchantDeliveryZones: String,
  MaxBillValue: Number,
  DineType: Number,
  BannerURL: String,
  CSP: String,
  RegionID: Number,
  DeliveryRange: Number,
  CountryCode: String,
  Location: String,
  ContactNo: String,
  OpeningHours: String,
  AllowScheduledOrder: Boolean,
  NoOfDaysScheduledOrders: Number,
  ScheduledOrderMerchantDisplayTime: Number,
  AllowInstanceOrder: Boolean,
  TotalOrders: Number,
  PrimarydeliveryRange: Number,
  PrimaryRangeDeliveryTime: String,
  PayMode: String,
  BankTransferAccountDetails: String,
  MobileAppUIType: Number,
  TotalProducts: Number,
  EstDeliveryCharges: Number,
  MerchantStatus: String,
  MerchantPromoText: String,
  ProductBannerUrl: String,
  IPGUrl: String,
  IPGUsername: String,
  IPGPassword: String,
  IPGMerchantNumber: String,
  IsMerchantCancelOrder: Boolean,
  MAXOrderRecivedCount: Number,
  CurrentOrderCount: Number,
  RefMID: Number,
  RefMerchant: String,
  PackingCharge: Number,
};
